export const mutation_delete_lastActivity = `
mutation deleteLastActivity($tenantId: String!, $aziendaId: Int!, $userId: String!) {
    delete_user_lastactivity(where: {TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId}, UserId: {_eq: $userId}}) {
        affected_rows
    }
}`;
export const mutation_add_lastActivity_byUserId = `
mutation addLastActivity($tenantId: String!, $aziendaId: Int!, $path: String!, $entityId: String, $entityName: String) {
    insert_user_lastactivity_one(object: { TenantId: $tenantId, AziendaId: $aziendaId, Path: $path, EntityId: $entityId, EntityName: $entityName}) {
        Id
    }
}`;